import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import components from './components'

Vue.config.productionTip = false

Vue.use(Vuelidate);
new Vue({
  components,
  render: h => h(App),
}).$mount('#app')
